import { render, staticRenderFns } from "./ccLiveboFangChater.vue?vue&type=template&id=7cedc78f&scoped=true"
import script from "./ccLiveboFangChater.vue?vue&type=script&lang=js"
export * from "./ccLiveboFangChater.vue?vue&type=script&lang=js"
import style0 from "./ccLiveboFangChater.vue?vue&type=style&index=0&id=7cedc78f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cedc78f",
  null
  
)

export default component.exports